/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppRoutes, COOKIE_OPTIONS, SessionTitles } from '@constants';
import { AgentLogged, Preferences, RolPermissions } from '@interfaces';
import { CookieService } from 'ngx-cookie-service';
import { WebsocketHandlerService } from '../../websocket';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private router: Router,
    private cookieService: CookieService,
    private webSocketService: WebsocketHandlerService,
  ) {}

  public isLoggedIn(): boolean {
    const accessToken: string = this.cookieService.get(
      SessionTitles.ACCESS_TOKEN,
    );
    return !!accessToken;
  }

  public getSessionToken(): string {
    return this.cookieService.get(SessionTitles.ACCESS_TOKEN) || '';
  }

  public getSessionValues(): AgentLogged | undefined {
    const session: string = this.cookieService.get(SessionTitles.SESSION);
    return session ? (JSON.parse(session) as AgentLogged) : undefined;
  }

  public setSessionValues(session: AgentLogged): void {
    this.cookieService.set(
      SessionTitles.ACCESS_TOKEN,
      session.accessToken,
      COOKIE_OPTIONS,
    );
    this.cookieService.set(
      SessionTitles.SESSION,
      JSON.stringify(session),
      COOKIE_OPTIONS,
    );
  }

  public getPermissionValues(): RolPermissions | undefined {
    const permissions: string = this.cookieService.get(
      SessionTitles.PERMISSIONS,
    );
    return permissions
      ? (JSON.parse(permissions) as RolPermissions)
      : undefined;
  }

  public setPermissionValues(permissions: RolPermissions): void {
    this.cookieService.set(
      SessionTitles.PERMISSIONS,
      JSON.stringify(permissions),
      COOKIE_OPTIONS,
    );
  }

  public hasPermission(permission: string): boolean {
    const rolPermissions: RolPermissions | undefined =
      this.getPermissionValues();
    if (rolPermissions) {
      return rolPermissions.permissions.includes(permission);
    }
    return false;
  }

  public logout(): void {
    this.cookieService.delete(SessionTitles.ACCESS_TOKEN, '/');
    this.cookieService.delete(SessionTitles.PERMISSIONS, '/');
    this.cookieService.delete(SessionTitles.SESSION, '/');
    this.webSocketService.disconnect();
    this.router.navigate([`${AppRoutes.LOGIN}`]);
  }

  public setPreferencesValues(preferences: any): void {
    this.cookieService.set(
      SessionTitles.PREFERENCES,
      JSON.stringify(preferences),
      COOKIE_OPTIONS,
    );
  }

  public getPreferencesValues(): any | undefined {
    const preferences: string = this.cookieService.get(
      SessionTitles.PREFERENCES,
    );
    return preferences ? (JSON.parse(preferences) as Preferences) : undefined;
  }
}
